import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-award-cards',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './award-cards.component.html',
    styleUrl: './award-cards.component.scss',
})
export class AwardCardsComponent {
    @Input() award: {
        id: number;
        titleKey: string;
        descriptionKey: string;
        image: string;
    };
}
